export const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "var(--main-25)",
    borderRadius: "999px",
    border: "none",
    paddingLeft: "12px",
    paddingRight: "12px",
    height: "48px",
    boxShadow: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused && "var(--main-100)",
    color: "#000",
    cursor: "pointer",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#4a4a4a",
    fontSize: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    overflow: "hidden",
    zIndex: 2,
  }),
};
